// LocationTimeTable.jsx
const mockLocationTime = [
  {
    sNo: 1,
    type: "Stockist",
    code: "4605",
    client: "Gupta Enterprises",
    pob: 0,
    city: "ALIRAJPUR",
    citySize: "1000",
    geoArea: "ALIRAJPUR",
    geoCode: "27 Oct 2025",
    workingDate: "27 Oct 2025",
    serverTime: "09:53 AM",
    distance: "467.88",
    clientLat: "22.304445",
    clientLng: "74.355422",
    clientAddress: "129, MG Rd, Alirajpur, Madhya Pradesh 457887, India",
    empLocation: "27 Oct 09:53 AM",
    empMock: false,
    empLat: "22.308057",
    empLng: "74.353066",
    empAddress: "8953+65G, Alirajpur, Madhya Pradesh 457887, India",
    freezeGeocode: "0.00",
    freezeDistance: "0.00",
    kmCovered: "0.00",
  },
  {
    sNo: 2,
    type: "Retailer",
    code: "1845286",
    client: "Chandani Medical",
    pob: 0,
    city: "ALIRAJPUR",
    citySize: "1000",
    geoArea: "Nanpur",
    geoCode: "22 May 2023",
    workingDate: "27 Oct 2025",
    serverTime: "11:34 AM",
    distance: "551.93",
    clientLat: "22.309710",
    clientLng: "74.352570",
    clientAddress: "Dahod Naka, 9852+WX8, Alirajpur, Madhya Pradesh 457887, India",
    empLocation: "27 Oct 11:34 AM",
    empMock: false,
    empLat: "22.311642",
    empLng: "74.347632",
    empAddress: "8953+65G, Alirajpur, Madhya Pradesh 457887, India",
    freezeGeocode: "0.69",
    freezeDistance: "0.69",
    kmCovered: "0.69",
  },
];

export default function LocationTimeTable() {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-blue-400 p-6">
        <h2 className="text-2xl font-bold text-white">TP Route Vs Covered Route Vs Covered Area</h2>
        <p className="text-blue-100 mt-2">Abdullah Khan - 27 Oct 2025</p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead className="bg-blue-50 sticky top-0">
            <tr>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">S.No</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Type</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Code</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Client</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">POB</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">City</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Geo Area</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Working Date</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Server Time</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Distance (M)</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Client Lat</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Client Lng</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Client Address</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Emp Lat</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">Emp Lng</th>
              <th className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-700">K.M. Covered</th>
            </tr>
          </thead>
          <tbody>
            {mockLocationTime.map((row) => (
              <tr key={row.sNo} className="hover:bg-gray-50 border-b border-gray-200">
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.sNo}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.type}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.code}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.client}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.pob}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.city}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.geoArea}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.workingDate}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.serverTime}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.distance}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.clientLat}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.clientLng}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700 text-sm">{row.clientAddress}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.empLat}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.empLng}</td>
                <td className="border border-gray-300 px-4 py-3 text-gray-700">{row.kmCovered}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="bg-gray-50 px-6 py-4 flex gap-4 justify-center">
        <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 font-medium">Print</button>
        <button className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 font-medium">Close</button>
        <button className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 font-medium">Export to Excel</button>
      </div>
    </div>
  );
}
